var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"v-sheet--offset mx-auto",style:({width: '1200px', height: '320px'}),attrs:{"id":"myChart","color":"blue","elevation":"12","max-width":"calc(100% - 30px)"}})}
var staticRenderFns = []

export { render, staticRenderFns }